// extracted by mini-css-extract-plugin
module.exports = {"header":"fe9808f","columns":"_6d6b66a","first":"f698a05","second":"_3398b7e"};